export default {
    // PricePlan - header
    yearly_payment:   "Roční platba",
    yearly_discount:  "-20% SLEVA",
    monthly_payment:  "Měsíční platba",
    trial_info:       "Všechny placené plány zahrnují 14denní zkušební verzi zdarma",
    try_free:         "Vyzkoušet zdarma",
    active_plan:      "Aktivní balíček",
    choose_plan:      "Zvolit balíček",
    upsell_msg:       "Podívej se, co můžeš získat již od {price} denně",
    compare_plans:    "Porovnat všechny funkce",
    your_plan:        "TVŮJ BALÍČEK",
    prepay_discount:  "předplatit se slevou",
    register:         "ZAREGISTROVAT",

    // Plan names
    plan_free:       "Zdarma",
    plan_profi:      "Profi",
    plan_small_team: "Malý tým",
    plan_big_team:   "Velký tým",
    up_to:           "až",

    // Plan features
    feat_unlimited_clients:   "Neomezený počet klientů",
    feat_unlimited_offers:    "Neomezený počet nabídek",
    feat_hide_logo:           "Skrýt logo DOFFERO",
    feat_custom_colors:       "Vlastní barvy v designu",
    feat_success_stats:       "Statistika úspěšnosti nabídek",
    feat_ai_descriptions:     "AI popisy",
    feat_team_accounts:       "Účty pro kolegy a obchodní tým",
    feat_seller_stats:        "Statistika úspěšnosti prodejců",
    feat_priority_support:    "Přednostní podpora",
    feat_ai_offers:           "AI tvorba cenových nabídek (připravujeme)",
    feat_margin:              "⁠Výpočet marže (připravujeme)",

    // dashboard.vue
    subscription_title:    "Správa předplatného",
    subscription_subtitle: "Vyber si balíček, který ti nejvíce vyhovuje",
    payment_success:       "Tvoje platba byla úspěšná. Předplatné se aktivuje za chvíli.",
    payment_failed:        "Tvoje platba nebyla úspěšná.",
    trial_expired:         "Zkušební doba tvého balíčku skončila. Pokud chceš obnovit balíček, klikni na tlačítko vedle, nebo si vyber z balíčků níže.",
    renew_plan:            "Obnovit balíček",
    active_plan_label:     "Tvůj aktivní balíček",
    started_label:         "Začátek",
    next_payment_label:    "Další platba",
    admin_created:         "Tvůj balíček byl vytvořen adminem",
    trial_active:          "Aktuálně máš aktivovaný balíček",
    trial_days:            "na {days} dní zdarma, který ti skončí",
    sub_cancels:           "Tvoje předplatné skončí",
    sub_active:            "Aktuálně máš aktivovaný balíček",
    sub_next_payment:      ", další platba proběhne",
    manage_subscription:   "Správa předplatného",
    subusers_info:         "Aktuálně máš {count} sub-účtů. Pro správnou funkčnost je potřeba zvolit alespoň balíček",
    subkonto_plural:       "sub-účtů",
    subkonto_singular:     "sub-účet",
    invoices_title:        "Platby a faktury",

    // InvoiceDetails
    billing_alert:         "Prosím, zkontroluj si své fakturační údaje",
    billing_check:         "Zkontroluj si fakturační údaje před platbou",
    billing_note:          "Tyto fakturační údaje budou na faktuře po platbě",
    save_data:             "Uložit údaje",
    continue_payment:      "Pokračovat na platbu",
    data_saved:            "Údaje byly úspěšně uloženy",
    section_country:            "Země",
    section_company:            "Společnost",
    section_address:            "Adresa",
    country_search_placeholder: "Vyhledat zemi…",
    vat_id_cz:                  "DIČ (DPH)",
    vat_verifying:              "Ověřuji DIČ v registru ARES…",
    vat_valid:                  "DIČ je platné",
    vat_invalid:                "Neplatné DIČ – zkontrolujte ho. Bez platného DIČ bude účtována DPH.",
    ares_checking:              "Ověřuji IČO v registru ARES…",
    ares_found_hint:           "Firma nalezena v registru ARES",
    ares_fill:                  "Doplnit údaje z ARES",
    ares_filled:               "Údaje doplněny z ARES",
    ares_not_found:            "IČO se v registru ARES nenašlo. Zkontrolujte ho, prosím.",
    ares_error:                "Registr ARES je momentálně nedostupný. Údaje můžete vyplnit ručně.",
    ares_bad_ico:              "IČO musí mít 8 číslic.",

    // Country names
    country_cz: "Česká republika",
    country_at: "Rakousko",
    country_pl: "Polsko",
    country_hu: "Maďarsko",
    country_hr: "Chorvatsko",
    country_me: "Černá Hora",
    country_mk: "Severní Makedonie",
    country_lv: "Lotyšsko",
    country_ee: "Estonsko",
    country_fi: "Finsko",
    country_se: "Švédsko",
    country_no: "Norsko",
    country_dk: "Dánsko",
    country_ie: "Irsko",
    country_gb: "Velká Británie",
    country_fr: "Francie",
    country_es: "Španělsko",
    country_gr: "Řecko",
    country_ch: "Švýcarsko",
    country_li: "Lichtenštejnsko",
    country_sm: "San Marino",
    country_va: "Vatikán",
    country_us: "Spojené státy americké",
    country_br: "Brazílie",
    country_ar: "Argentina",
    country_cl: "Chile",
    country_au: "Austrálie",
    country_nz: "Nový Zéland",
    country_kr: "Jižní Korea",
    country_cn: "Čína",
    country_id: "Indonésie",
    country_ph: "Filipíny",
    country_ae: "Spojené arabské emiráty",
    country_sa: "Saudská Arábie",
    country_za: "Jižní Afrika",
    country_ng: "Nigérie",
    country_ke: "Keňa",
    country_other: "Jiné",

    // stripe/dashboard remaining
    invoice_date_col:    "Datum",
    invoice_num_col:     "Číslo faktury",
    no_invoices:         "Aktuálně nemáš žádné platby a faktury",
    cancel_sub:          "Zrušit předplatné",
    renew_sub:           "Obnovit předplatné",
    change_billing:      "Změnit údaje na faktuře",
    period_monthly:      "Měsíčně",
    period_yearly:       "Ročně",

    // SubscriptionOfferAlert
    alert_close:         "Zavřít",
    alert_manage_sub:    "Spravovat předplatné",
    alert_renew:         "Obnovit",
    alert_offers_counter:"vytvořených nabídek",
    alert_upgrade_title: "Tvůj účet vyžaduje vyšší balíček",
    alert_upgrade_text:  "Od 1. května 2025 přechází DOFFERO na nový placený model. Abys mohl/la pracovat se všemi nabídkami, vyber si vyšší balíček. <a href='/cennik'>Více info</a>",
    alert_main_upgrade:  "Hlavní účet vyžaduje vyšší balíček",
    alert_trial_ended:   "Tvoje zkušební období skončilo",
    alert_trial_text:    "Tvoje zkušební verze DOFFERO® právě skončila. Věříme, že sis ji užil/a a zjistil/a, jak ti může pomoci s tvorbou cenových nabídek. <br><br> Pokud chceš pokračovat s plným přístupem, vyber si jeden z balíčků a aktivuj si předplatné.",

    // PricePlan remaining
    plan_free_clients:   " ⁠Maximálně 3 klienti",
    plan_free_offers:    "Maximálně 3 vytvořené nabídky",
    plan_small_team_acc: "Až 5 účtů pro kolegy a obchodní tým",
    plan_big_team_acc:   "Až 20 účtů pro kolegy a obchodní tým",
    feat_unlimited_offers2: "Neomezený počet nabídek",
    sub_status_cancelled:"Zrušeno",
};